// extracted by mini-css-extract-plugin
export default {"card":"wuj18","cardInfo":"vAlbI","icon":"ak6wC","cardWarning":"CCMte","inner":"BNaJe","title":"jjgpc","text":"R8oMM","button":"niVAD"};